import { ChangeEvent, useEffect, useRef, useState } from "react";
import cn from "classnames";
import styles from "./Field.module.scss";
import { IFieldProps } from "./Field.props";
import Copy from "../Copy/Copy";
import Icon from "../Icon/Icon";

import close from "@assets/icons/close.svg";
import eye from "@assets/icons/eye.svg";
import no_eye from "@assets/icons/no-eye.svg";

export default function Field({
  label,
  // name,
  id,
  type,
  className,
  copy,
  disabled = false,
  isError = false,
  defaultValue,
  enteredValue,
  reset,
  upperCase,

  onDelete,
  onChange,
  ...props
}: IFieldProps) {
  const ref = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState<string | number>(
    (defaultValue as string | number) || ""
  );
  const [showPass, setShowPass] = useState<boolean>(false);
  useEffect(() => {
    if (enteredValue) setValue(enteredValue);
  }, [enteredValue]);

  const onChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    onChange && onChange(e);
  };

  const isPassword = type === "password";

  useEffect(() => {
    if (!ref.current) return;
    const listener = (e: MouseEvent) => {
      if (
        e.target instanceof HTMLButtonElement &&
        e.target.textContent === "Send"
      ) {
        setTimeout(() => setValue(""), 1);
      }
    };
    document.addEventListener("click", listener);
    return () => document.removeEventListener("click", listener);
  }, []);

  //for reset
  useEffect(() => {
    if (!reset) return;
    setValue("");
  }, [reset]);

  return (
    <div className={cn(styles.wrapper, className)}>
      <label className={styles.name}> {label ? label : props.name}</label>
      <div className={styles.input}>
        <input
          tabIndex={disabled ? -1 : 0}
          type={showPass ? "text" : type}
          autoComplete={type === "email" ? "on" : "off"}
          value={upperCase ? value.toString().toLocaleUpperCase() : value}
          // defaultValue={defaultValue}
          onChange={disabled ? undefined : onChangeValue}
          className={cn({
            [styles.disabled]: disabled,
            [styles.error]: isError,
          })}
          onBlur={(e) =>
            type === "email"
              ? setValue((value as string).replace(/\s+/g, ""))
              : null
          }
          ref={ref}
          {...props}
          name={id}
        />
      </div>
      {copy && !!value && <Copy text={`${value}`} className={styles.copy} />}
      {onDelete && (
        <Icon
          src={close}
          className={styles.delete}
          onClick={onDelete}
          noHover
        />
      )}
      {isPassword && (
        <img
          className={styles.eye}
          src={showPass ? no_eye : eye}
          alt='watt manor'
          onClick={() => setShowPass(!showPass)}
        />
      )}
      <input value={value} id={id} hidden aria-hidden disabled />
    </div>
  );
}
